module.exports = __webpack_public_path__ + "static/media/icono_asesor_de_imagen.1bb41c55.svg";